module.exports = __webpack_public_path__ + "img/1.1d9fa6b3.jpg";